<template>
    <div class="position-relative task-list-wrapper">
        <div class="container py-3">
            <list-group v-for="stage in taskStages"
                        v-bind:key="stage._id"
                        v-bind:title="stage.name"
                        v-bind:stage="stage">
            </list-group>
        </div>

        <task-details></task-details>
    </div>
</template>

<script>
import ListGroup from "./List/ListGroup";
import TaskDetails from "./TaskDetails";
export default {
    name: "TaskList",
    components: {
        TaskDetails,
        ListGroup,

    },
    data () {
        return {

        };
    },
    computed: {
        isLoading() {
            return this.$store.state.tasks.isStagesLoading;
        },
        taskStages() {
            return this.$store.state.tasks.stages;
        },
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.task-list {

}
</style>
